import { createSlice } from "@reduxjs/toolkit";
import { setCompanyData, setCompany, clearCompany, clearCompanyData } from "../database/selectedCompanySlice";

const initialState = {
	data: null,
	loading: false,
	error: null,
};

// The list belongs to the company it was fetched in. When the selected company changes it is wrong
// for the new one, so it's dropped (the page then shows its loader, not another company's processes).
const resetForCompanyChange = () => initialState;

const workflowHistoriesSlice = createSlice({
	name: "workflowHistories",
	initialState,
	reducers: {
		// payload: { request, needsLabels } - see workflowsSaga (getMyProcessesSaga).
		fetchWorkflowHistoriesRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchWorkflowHistoriesSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload;
		},
		fetchWorkflowHistoriesFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
		// A response that arrived after the company changed was discarded: just stop loading.
		fetchWorkflowHistoriesDiscarded: (state) => {
			state.loading = false;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(setCompanyData, resetForCompanyChange)
			.addCase(setCompany, resetForCompanyChange)
			.addCase(clearCompany, resetForCompanyChange)
			.addCase(clearCompanyData, resetForCompanyChange);
	},
});

export const {
	fetchWorkflowHistoriesRequest,
	fetchWorkflowHistoriesSuccess,
	fetchWorkflowHistoriesFailure,
	fetchWorkflowHistoriesDiscarded,
} = workflowHistoriesSlice.actions;

export default workflowHistoriesSlice.reducer;
